/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Person/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Person({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/EffectiveDate/Status/InfoTooltip/Content/Inactivated/Person"
  
}) {
let insuranceSubscriptionTypeLastChangedBy0PersonValueData = fromData.useDataFormat({ viewPath,
context: 'insurance_subscription',
path: 'type_last_changed_by[0].person',
format: fromFormat.personName,
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsWhite}
 data="insurance_subscription.type_last_changed_by[0].person"
 format="/Data/format.js personName"
 text={insuranceSubscriptionTypeLastChangedBy0PersonValueData}
/>
{children}
</React.Fragment>)
}